export const imageLoader = ({ src }: { src: string }) => `${src}`;
